import React from 'react';
import type {MainConsumerContextType} from 'src/types/Screen';
export default React.createContext<MainConsumerContextType | null | undefined>(
  undefined,
);
